<template>
  <div class="rightDialog">
    <div class="center-card" :body-style="treeCard">
      <div class="centerbg">
        <div class="imgone">
          <img src="@/assets/images/threeSolid/threecor.png" />
        </div>
        <div class="imgtwo">
          <img src="@/assets/images/threeSolid/threecor.png" />
        </div>
        <div class="imgthree">
          <img
            v-if="dialogCount.imageUrl"
            :src="imgURL + dialogCount.imageUrl"
          />
        </div>
        <div class="centerbtn" v-if="dialogCount.furtherList">
          <div
            class="btnitem"
            :style="{ background: item.show ? '#388ff3' : '#ccc' }"
            @click="clickCenter(item)"
            v-for="item in dialogCount.furtherList"
            :key="item.type"
          >
            <el-tooltip
              class="box-item"
              effect="dark"
              :content="item.name"
              placement="top-start"
            >
              <span> {{ item.name }}</span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <el-card class="tree-card" :body-style="treeCard">
      <div class="basic">
        <div v-if="showContent.showType === 'Obj'">
          <div class="basicTitle">{{ showContent.title }}</div>
          <template v-if="showContent.content">
            <template v-for="item in showContent.columns" :key="item.prop">
              <div class="basicItem">
                <span>{{ item && item.label }}:</span>
                <span v-for="(l, index) in showContent.content" :key="index">
                  {{ (l && l[item.prop]) || "--" }}
                </span>
              </div>
            </template>
          </template>
        </div>
        <div v-if="showContent.showType === 'List'">
          <div class="basicTitle">{{ showContent.title }}</div>
          <template v-if="showContent.content">
            <ul
              class="search-results"
              v-for="(element, ind) in showContent.content"
              :key="ind"
            >
              <template v-for="item in showContent.columns" :key="item">
                <li class="results-item">
                  <div class="item-details">
                    <div class="details-info">
                      <span>{{ item && item.label }}:</span>
                      <span v-for="(l, index) in [element]" :key="index">
                        {{ (l && l[item.prop]) || "--" }}
                      </span>
                    </div>
                  </div>
                </li>
              </template>
            </ul>
          </template>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import {
  defineComponent,
  reactive,
  toRefs,
  watchEffect,
  watch,
  ref,
} from "vue";
import { cyryxxInfo } from "@/api/threeSolid/fileManagement.js";
import {
  peopleright,
  houseright,
  communityright,
  equipmentright,
  powerright,
  securityright,
} from "./fileManagement";
import TDasFhCyryxxInfo from "./commentByJson/TDasFhCyryxxInfo.json";
export default defineComponent({
  name: "",
  components: {},
  props: {
    showType: {
      type: String,
    },
    dialogCount: {
      type: Object,
    },
  },
  setup(props, context) {
    const data = reactive({
      imgURL: window.imgURL,
      rowItem: {},
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      showContent: {
        showType: "Obj", //定义展示对象还是列表  Obj、List
        title: "",
        content: null,
        columns: null,
      },
      importObj: {
        prisonInfo: peopleright,
        houseInfo: houseright,
        regionInfo: communityright,
        equipmentInfo: equipmentright,
        strengthInfo: powerright,
        securityInfo: securityright,
      },
    });
    const refData = toRefs(data);

    watch(
      () => props.dialogCount,
      (v) => {
        if (v.furtherList && v.furtherList.length > 0) {
          const aa = v.furtherList[0];

          v.furtherList.push({
            id: 50,
            name: "从业人员信息",
            further: "unitInfoList",
            type: "FH",
          });
          clickCenter(aa);
        }
      }
    );
    const tableRef = ref();
    // 点击中间切换
    const clickCenter = (item) => {
      console.log(
        "点击中间切换~ item",
        item,
        props.showType,
        props.dialogCount
      );
      props.dialogCount.furtherList.forEach((el) => {
        el.show = false;
        if (item.id == el.id) {
          el.show = true;
        }
      });
      if (item.type == "FH") {
        getCyryxxInfo();
        return;
      }
      let column = item.further.replace(/List/g, "");
      data.showContent.title = item.name + "";
      data.showContent.content = props.dialogCount[item.further];
      data.showContent.columns = data.importObj[column];
      if (data.showContent.content.length > 1) {
        data.showContent.showType = "List";
      } else {
        data.showContent.showType = "Obj";
      }
      console.log(data.showContent);
      data.rowItem = item;
    };
    const getCyryxxInfo = async () => {
      //烽火-从业人员信息-信息表
      const res = await cyryxxInfo({ rid: "1" });
      if (res.byId) {
        data.showContent.showType = "Obj";
        data.showContent.title = TDasFhCyryxxInfo.title;
        data.showContent.content = [res.byId];
        data.showContent.columns = TDasFhCyryxxInfo.content;
        console.log(data.showContent);
      }
    };
    // getCyryxxInfo();

    return {
      ...refData,
      clickCenter,
      tableRef,
      communityright,
      equipmentright,
      powerright,
      securityright,
      peopleright,
      houseright,
    };
  },
});
</script>
<style lang="scss" scoped>
.shengluehao {
  height: 24px;
  width: 242px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.rightDialog {
  display: flex;
  flex: 1;
  overflow: auto;
  width: 100%;
  height: 100%;
}
.tree-card {
  height: 100%;
  width: 400px;
}
.basic {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  .basicTitle {
    color: #000;
    line-height: 40px;
    font-weight: bold;
  }
  .basicImgbox {
    width: 100%;
    height: 180px;
    display: flex;
    .basicImg {
      width: 110px;
      height: 100%;
      margin-right: 10px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .basicName {
      flex: 1;
    }
  }
  .basicItem {
    flex: 1;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #f1f2f5;
    padding: 10px 0;
    line-height: 24px;
    span {
      // width: 206px;
    }
  }
}
.center-card {
  flex: 1;
  position: relative;
  .centerbg {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    width: 386px;
    height: 386px;
    img {
      width: 100%;
      height: 100%;
    }
    .imgone {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .imgtwo {
      width: 75%;
      height: 75%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .imgthree {
      width: 50%;
      height: 50%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background-image: url("~@/assets/images/threeSolid/threecor.png");
      background-size: 100%;
      img {
        width: 100%;
        height: 100%;
        border-radius: 100%;
      }
    }
  }
  .centerbtn {
    width: 386px;
    height: 386px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .btnitem {
      width: 66px;
      height: 66px;
      text-align: center;
      line-height: 66px;
      border-radius: 100%;
      font-size: 10px;
      color: #fff;
      background: #388ff3;
      position: absolute;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      cursor: pointer;
      &:nth-child(1) {
        left: 70%;
        top: 1%;
      }
      &:nth-child(2) {
        left: 85%;
        top: 20%;
      }
      &:nth-child(3) {
        left: 90%;
        top: 45%;
      }
      &:nth-child(4) {
        left: 85%;
        top: 70%;
      }
      &:nth-child(5) {
        left: 65%;
        top: 88%;
      }
      &:nth-child(6) {
        left: 35%;
        top: 90%;
      }
      &:nth-child(7) {
        left: 95%;
        top: 0%;
      }
      &:nth-child(8) {
        left: 110%;
        top: 25%;
      }
      &:nth-child(9) {
        left: 115%;
        top: 50%;
      }
      &:nth-child(10) {
        left: 110%;
        top: 75%;
      }
      &:nth-child(11) {
        left: 90%;
        top: 95%;
      }
      &:nth-child(12) {
        left: 70%;
        top: 110%;
      }
      &:nth-child(13) {
        left: 40%;
        top: 70%;
      }
      &:nth-child(14) {
        left: 50%;
        top: 60%;
      }
      &:nth-child(15) {
        left: 50%;
        top: 60%;
      }
      // &:nth-child(1) {
      //   left: 50%;
      //   top: -30px;
      // }
      // &:nth-child(2) {
      //   left: 75%;
      //   top: 30px;
      // }
      // &:nth-child(3) {
      //   left: 90%;
      //   top: 50%;
      // }
      // &:nth-child(4) {
      //   left: 70%;
      //   top: 83%;
      // }
      // &:nth-child(5) {
      //   left: 35%;
      //   bottom: -27px;
      // }
      // &:nth-child(6) {
      //   left: 20%;
      //   line-height: 42px;
      // }
      // &:nth-child(7) {
      //   left: -3%;
      //   bottom: 24%;
      // }
      // &:nth-child(8) {
      //   left: -1%;
      //   top: 110px;
      // }
      // &:nth-child(9) {
      //   left: 20%;
      //   top: 28%;
      // }
      // &:nth-child(10) {
      //   left: 20%;
      //   top: 0px;
      // }
      // &:nth-child(11) {
      //   left: 30%;
      //   top: 50%;
      // }
      // &:nth-child(12) {
      //   left: 50%;
      //   top: 60%;
      // }
      // &:nth-child(13) {
      //   left: 60%;
      //   top: 60%;
      // }
      // &:nth-child(14) {
      //   left: 50%;
      //   top: 60%;
      // }
      // &:nth-child(15) {
      //   left: 50%;
      //   top: 60%;
      // }
    }
  }
}
.search-results {
  width: 100%;
  flex: 1;
  overflow: auto;
  margin-top: 5px;
  border-bottom: 1px solid #aab2c5;
  .results-item {
    margin: 10px 0;
    width: 100%;
    @include flex-row-s-c;
    .item-img {
      width: 100px;
      img {
        width: 100%;
      }
    }
    .item-details {
      flex: 1;
      margin-left: 10px;
      .details-info {
        font-size: 14px;
        @include flex-row-sb-c;
        & > span {
          display: inline-block;
        }
        .label {
          width: 90px;
        }
        .value {
          flex: 1;
        }
      }
    }
  }
}
</style>
